import { observer } from 'mobx-react-lite'
import { type FirmDashboardJobTableViewModel } from '@/features/jobs/dashboard/FirmDashboardJobTableViewModel'
import { useToggle } from '@/hooks/state-hooks'
import { FilterControlsContainer } from '@/components/FilterControls/FilterControlsContainer'
import { PrimaryControls } from '@/features/jobs/list/components/JobManagement/JobsViewerHeader/PrimaryControls'
import { FirmDashboardJobsViewerHeader } from '@/features/jobs/dashboard/components/FirmDashboardJobsViewerHeader'
import { FirmDashboardTableControls } from '@/features/jobs/dashboard/components/FirmDashboardJobsViewerHeader/FirmDashboardTableControls'

export interface FirmDashboardJobsViewerHeaderContainerProps {
  vm: FirmDashboardJobTableViewModel
}

export const FirmDashboardJobsViewerHeaderContainer = observer(
  function FirmDashboardJobsViewerHeaderContainer({
    vm,
  }: FirmDashboardJobsViewerHeaderContainerProps) {
    const hasFilters = vm.searcher.filters.appliedFilterCount > 0
    const showingFilterControls = useToggle(hasFilters)

    return (
      <FirmDashboardJobsViewerHeader
        primaryControls={
          <PrimaryControls
            renderMenu={(button) => (
              <FirmDashboardTableControls
                onExportCsv={vm.columnsVm.exportJobsAsCSV}
                button={button}
              />
            )}
            onChange={vm.searcher.searchText.change}
            onShowFilterControls={showingFilterControls.toggle}
            filterCount={vm.searcher.filters.appliedFilterCount}
            value={vm.searcher.searchText.value}
          />
        }
        filterControls={
          <FilterControlsContainer
            active={showingFilterControls.isEnabled}
            vm={vm.searcher.filters}
            editorTestId="job"
            testId="job-filter"
          />
        }
      />
    )
  },
)
